// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"397":"ca64f4b1","447":"93849129"}[chunkId] + ".chunk.css";
};